import React from "react";

type Props = {
  error: string;
};

export function ErrorMessage({ error }: Props) {
  return <p style={{ color: "red", paddingTop: 10 }}>{error}</p>;
}
